import getSensors from '../../scripts/get-sensors';
import getSensorGroups from '../../scripts/get-sensor-groups'
import getSensorById from '../../scripts/get-sensor-by-id';
import BetterSelect from '../../scripts/better-select';
import sort from 'array-sort';
import serialize from 'form-serialize'
import isFunction from 'lodash.isfunction'
import roundTo from 'round-to'
import getAlerts from '../../scripts/get-alerts'
import median from '@extra-math/median'
import noSensorsOverlay from '../../components/no-sensors-overlay'
import getContacts from '../../scripts/get-contacts'
import isAccountReadOnly from '../../scripts/is-account-read-only'
import DirtyForm from 'dirty-form'
import SensorSettingsProbe from './settings/probe'
import CalibrationOffset from './settings/calibration_offset'
import getProbeSensorTypes from '../../util/get-probe-sensor-types'
import getHeatIndex from '../../util/get-heat-index'
import celsiusToFahrenheit from '../../util/celsius-to-fahrenheit'
import fahrenheitToCelsius from '../../util/fahrenheit-to-celsius'
import isUndefined from 'lodash.isundefined'
import SensorLogSecs from './settings/log_secs'
import Branding from '../../components/branding'
import RequestQueueInstance from '../../util/request-queue'
import DeleteSensor from './settings/delete_sensor'

class SensorsLite {

  constructor () {

    this.$sensor = $('.sensor');
    this.$sensorSelect = this.$sensor.find('.sensor-settings__sensor-select');
    this.$settings = $('.sensor-settings__content');
    this.$details = $('.sensor-details__content');
    this.lastViewedSensor = window.localStorage.getItem('last-viewed-sensor');

    this.groups = [];
    this.alerts = {};

    const url = new URL(window.location);

    // select parameter sensor first
    // else use the last viewed sensor
    // else use the first sensor

    if(url.searchParams.get('id')) {

      this.currentSensorId = url.searchParams.get('id');

    } else if(this.lastViewedSensor) {

      this.currentSensorId = this.lastViewedSensor;

    } else {

      if (this.$sensor[0].dataset.sensor) {
        this.currentSensorId = this.$sensor[0].dataset.sensor;
      } else {
        this.currentSensorId = null;
      }

    }

    this.currentSensor = null;
    this.SensorLogSecs = new SensorLogSecs();

    this.init().then(() => {

      this.interactions();

    });

  }

  selectSensor(sensorId) {

    this.$settings.addClass('loading-overlay');
    this.$details.addClass('loading-overlay');

    getSensorById(sensorId).then(sensor => {

      Branding.maybeUpdateBranding(sensor.sensor_id)

      this.currentSensorId = sensor.sensor_id;
      this.currentSensor = sensor;

      console.log({sensor})

      this.lastViewedSensor = this.currentSensorId;
      window.localStorage.setItem('last-viewed-sensor', this.currentSensorId);

      // push the current selected sensor to history
      const url = new URL(window.location);

      if(url.searchParams.get('id') !== this.currentSensorId) {
        url.searchParams.set('id', this.currentSensorId);
        window.history.pushState({}, '', url);
      }

      let hasConnectionAlert = false;

      Object.keys(this.alerts).forEach(alertId => {

        const alert = this.alerts[alertId];

        if(alert.reading_type === 'connection' && alert.enabled == 1) {
          if(alert.sensors_global == 1) {
            hasConnectionAlert = true;
          } else if(sensor.alerts.includes(alertId)) {
            hasConnectionAlert = true;
          }
        }

      });

      const html = `
      
        <form action="" method="post">
        
        <div class="sensor-settings__header">
          <h2>Sensor Settings</h2>
        </div>
        
        <label>
          Sensor Name:
          <input type="text" name="sensor_name" value="${sensor.sensor_name}" >
        </label>
        
        ${window.currentUser.use_sensor_groups == 1 ? `
        
        <h3>Sensor Group</h3>
        <div class="setting">
          
          <div class="setting__description">The group sets the default alerts and check-in interval for the sensor</div>
          
          <div class="setting__input">
            <div class="setting__label">Group</div>
            <select class="settings-select" name="group">
              ${this.groups.map(group => {
        return `<option value="${group.id}" ${group.id == sensor.group ? 'selected' : ''}>${group.name}</option>`;
      }).join("\n")}
            </select>
          </div>
        </div>
        
        <div class="setting-divider"></div>
        
        <div class="setting">
        
          <div class="setting__input">
            
            <div class="setting__switch">
              <div class="setting__switch__value">
                <div class="switch medium">
                  <input class="switch-input" type="checkbox" id="use_sensor_settings" name="use_sensor_settings" value="1" ${sensor.use_sensor_settings == 1 ? 'checked' : ''} />
                  <label class="switch-paddle" for="use_sensor_settings">
                    <span class="switch-active">Yes</span>
                    <span class="switch-inactive">No</span>
                  </label>
                </div>
              </div>
              <div class="setting__switch__label">Override group settings for this sensor</div>
            </div>

          </div>
          <div class="setting__description">Use check-in settings specific to this sensor instead of what's used by its group</div>
        </div>
        <!-- conditional container for enterprise -->
        <div class="setting setting--conditional ${sensor.use_sensor_settings == 1 ? 'is-active' : ''}" data-for="use_sensor_settings">
        `: ``}
        
        <div class="setting">
          
          <div class="setting__input">
            <div class="setting__label">Get Readings Every:</div>
            <select class="settings-select" name="send_interval">
              <option value="3600" ${sensor.send_interval == 3600 ? 'selected' : '' }>60 minutes (recommended)</option>
              <option value="1800" ${sensor.send_interval == 1800 ? 'selected' : '' }>30 minutes</option>
              <option value="900" ${sensor.send_interval == 900 ? 'selected' : '' }>15 minutes</option>
            </select>
          </div>
        </div>
        
        ${this.renderAlertInterval()}
        
        ${window.currentUser.use_sensor_groups == 1 ? `
        </div><!-- end conditional container for enterprise -->
        `: ``}
        
        ${SensorSettingsProbe(sensor)}
                
        <div class="setting">
        
        <input type="hidden" class="setting__dropdown__select" name="connection_sensitivity" value="2" />
                       
        </div>
        
        ${this.SensorLogSecs.render(sensor)}
        
        <div class="divider"></div>
        
        ${CalibrationOffset(sensor)}
        
        <div class="setting-save">
          <div class="setting-save__button">
            <button 
              type="submit" 
              class="button button--blue small-only-expanded"
              ${isAccountReadOnly() ? 'disabled' : ''}
            >
              Save Sensor Settings
            </button>
          </div>
          <div class="setting-save__message"></div>
        </div>
        </form>
      `;

      this.$settings.html(html);

      new DirtyForm(this.$settings[0].querySelector('form'), {
        message: 'You have unsaved changes for your sensor, are you sure you want to leave?'
      });

      this.renderDetails();
      this.updateSendIntervals();
      this.updateAlertIntervals();
      this.updateConnectionSensitivity();

      this.$settings.removeClass('loading-overlay');
      this.$details.removeClass('loading-overlay');

      // disable form for no permissions user
      if(window.currentUser.level && window.currentUser.level == 0) {
        this.$settings.find('button').attr('disabled', true);
      }

    });

  }

  renderAlertInterval() {

    const sensor = this.currentSensor;

    if(sensor.version >= 2000) {
      // v2

      return `
      <div class="setting">
        
        <div class="setting__input">
          
          <div class="setting__switch">
            <div class="setting__switch__value">
              <div class="switch medium">
                <input class="switch-input" type="checkbox" id="use_alert_interval" name="use_alert_interval" value="1" ${sensor.use_alert_interval == 1 ? 'checked' : ''} />
                <label class="switch-paddle" for="use_alert_interval">
                  <span class="switch-active">On</span>
                  <span class="switch-inactive">Off</span>
                </label>
              </div>
            </div>
            <div class="setting__switch__label">Get readings more often if an alert is triggered</div>
          </div>

        </div>
      </div>
      <div class="setting setting--conditional ${sensor.use_alert_interval == 1 ? 'is-active' : ''}" data-for="use_alert_interval">
        <div class="setting__input">
          
          <div class="setting__label">Update Every:</div>
          
          <div class="setting__dropdown c-margin-md">
            <div class="setting__dropdown__select">
              <select name="alert_interval"></select>
            </div>
            <div class="setting__dropdown__label text--bold">
              Until conditions return to normal
            </div>
          </div>
          
          <div class="setting-disclaimer" style="margin-bottom: 15px;">
            More frequent check-ins will reduce battery life.
          </div>
        </div>
      </div>
      `;

    } else {

      return `
      <div class="setting">
        
        <div class="setting__input">
          
          <div class="setting__switch">
            <div class="setting__switch__value">
              <div class="switch medium">
                <input class="switch-input" type="checkbox" id="use_alert_interval" name="use_alert_interval" value="1" ${sensor.use_alert_interval == 1 ? 'checked' : ''} />
                <label class="switch-paddle" for="use_alert_interval">
                  <span class="switch-active">On</span>
                  <span class="switch-inactive">Off</span>
                </label>
              </div>
            </div>
            <div class="setting__switch__label">Get readings more often if sensor is above or below chosen values</div>
          </div>

        </div>
      </div>
      
      <div class="setting setting--conditional ${sensor.use_alert_interval == 1 ? 'is-active' : ''}" data-for="use_alert_interval">
        <div class="setting__input">
          
          <div class="setting__label">Check Every:</div>
          
          <select name="alert_interval"></select>
          
          <div class="sensor-setting-alert-conditions">
            <div class="sensor-setting-alert-condition">
              <label>If temp is below</label>
              <input type="number" name="alert_temp_below" class="alert-number-select" value="${sensor.alert_temp_below !== '' ? celsiusToUserTemp(sensor.alert_temp_below) : ''}" /> &deg;${window.getUserTempPref()}
            </div>
            <div class="sensor-setting-alert-condition">
              <label>If temp is above</label>
              <input type="number" name="alert_temp_above" class="alert-number-select" value="${sensor.alert_temp_above !== '' ? celsiusToUserTemp(sensor.alert_temp_above) : ''}" /> &deg;${window.getUserTempPref()}
            </div>
            <div class="sensor-setting-alert-condition">
              <label>If humidity is below</label>
              <input type="number" name="alert_humidity_below" class="alert-number-select" value="${sensor.alert_humidity_below}" /> %
            </div>
            <div class="sensor-setting-alert-condition">
              <label>If humidity is above</label>
              <input type="number" name="alert_humidity_above" class="alert-number-select" value="${sensor.alert_humidity_above}" /> %
            </div>
          </div>
          
        </div>
      </div>
      
      <div class="setting-disclaimer" style="margin-bottom: 15px;">
        More frequent check-ins will reduce battery life.
      </div>
      `;

    }
  }

  renderDetails() {

    if(this.currentSensor === null) {
      console.error('no sensor set');
      return;
    }

    // initializing sensor html for new sensors
    if(this.currentSensor.last_temp == 0 && this.currentSensor.last_humidity == 0 && this.currentSensor.last_voltage == 0) {

      const currentTime = new Date();
      const lastCheckin = window.datetimeToDate(this.currentSensor.last_checkin);

      const timeDifference = (currentTime - lastCheckin) / 60000; // 60000 milliseconds in a minute

      console.log(timeDifference);

      if(timeDifference > 60) {

        let lastCheckinMoment = window.getUserTimezoneDate(this.currentSensor.last_checkin);

        this.$details.html(`
        <div class="sensor-details__row">
          <div class="sensor-details__label">Name</div>
          <div class="sensor-details__value">${this.currentSensor.sensor_name}</div>
        </div>
        <div class="sensor-details__row">
          <div class="sensor-details__label">ID</div>
          <div class="sensor-details__value">${this.currentSensor.sensor_id}</div>
        </div>
        <div class="sensor-details__row">
          <div class="sensor-details__label">Status</div>
          <div class="sensor-details__value">Offline - No Data Since Activation (${lastCheckinMoment.format("MM/DD/YYYY")})</div>
        </div>
        
      `);

      } else {

        this.$details.html(`
        <div class="sensor-details__row">
          <div class="sensor-details__label">Name</div>
          <div class="sensor-details__value">${this.currentSensor.sensor_name}</div>
        </div>
        <div class="sensor-details__row">
          <div class="sensor-details__label">ID</div>
          <div class="sensor-details__value">${this.currentSensor.sensor_id}</div>
        </div>
        <div class="sensor-details__row">
          <div class="sensor-details__label">Status</div>
          <div class="sensor-details__value">Initalizing</div>
        </div>
        <div class="sensor-details__row">
          This is a new sensor; allow up to 2 minutes before new readings start showing.
        </div>
        
      `);

      }



      return;

    }

    const values = [
      {
        key: 'sensor_name',
        label: 'Name',
      },
      {
        key: 'sensor_id',
        label: 'ID',
      },
      {
        key: 'last_checkin',
        label: 'Last Reading',
        value: item => {
          const d = window.getUserTimezoneDate(item.last_checkin);
          return `${d.format('MMM DD, YYYY hh:mm a')}`;
        }
      },
      {
        key: 'last_tcTemp',
        label: 'Probe Temp',
        value: item => {
          if(!isUndefined(item.last_tcTemp)) {
            if(item.last_tcTemp === 'n') {
              return 'N/A';
            } else {
              return `${window.celsiusToUserTemp(item.last_tcTemp, 1)}&deg;${currentUser.temp_pref}`;
            }
          }

          return null;

        }
      },
      {
        key: 'last_temp',
        label: 'Temperature',
        value: item => {
          return `${window.celsiusToUserTemp(item.last_temp, 1)}&deg;${currentUser.temp_pref}`;
        }
      },
      {
        key: 'last_humidity',
        label: 'Humidity',
        value: item => {

          return `${roundTo(item.last_humidity, 1)}%`;

        }
      },
      {
        key: 'last_humidity',
        label: 'Dewpoint',
        value: item => {
          return window.getDewpoint(this.currentSensor.last_humidity, this.currentSensor.last_temp);
        }
      },
      {
        key: 'last_humidity',
        label: 'Heat Index',
        value: item => {

          const temp = celsiusToFahrenheit(this.currentSensor.last_temp);
          const humidity = this.currentSensor.last_humidity;

          const heatIndexF = getHeatIndex(temp, humidity);

          if(window.getUserTempPref() === 'C') {
            return `${fahrenheitToCelsius(heatIndexF, 1)}&deg;${currentUser.temp_pref}`;
          } else {
            return `${roundTo(heatIndexF, 1)}&deg;${currentUser.temp_pref}`;
          }
        }
      },
      {
        key: 'last_pwr',
        label: 'Power Source',
        value: item => {

          if(isUndefined(item.last_pwr)) {
            return null;
          }

          return item.last_pwr == 1 ? "USB" : "Battery"
        }
      },
      {
        key: 'last_voltage',
        label: 'Battery',
        value: item => {

          if(!isUndefined(item.last_battPct)) {
            return `${window.getBatteryIconPct(item.last_battPct)}`;
          }

          if(isNaN(item.last_voltage)) {
            return '&ndash;';
          }

          item.last_voltage = parseFloat(item.last_voltage);

          const pct = window.getBatteryPercentage(item.last_voltage);

          if(pct > 80) {
            return `<img src="${window.site.home}/images/battery_level_100.png" class="battery-icon" /> ${pct}%`;
          } else if(pct > 60) {
            return `<img src="${window.site.home}/images/battery_level_80.png" class="battery-icon" /> ${pct}%`;
          } else if(pct > 40) {
            return `<img src="${window.site.home}/images/battery_level_60.png" class="battery-icon" /> ${pct}%`;
          } else if(pct > 20) {
            return `<img src="${window.site.home}/images/battery_level_40.png" class="battery-icon" /> ${pct}%`;
          } else if(pct > 10) {
            return `<img src="${window.site.home}/images/battery_level_20.png" class="battery-icon" /> ${pct}%`;
          } else {
            return `<img src="${window.site.home}/images/battery_level_10.png" class="battery-icon" /> ${pct}%`;
          }

        }
      },
      {
        key: 'sensor_mac_addr',
        label: 'MAC ADDR',
        value: item => {
          return item.sensor_mac_addr;
        }
      },
      {
        key: 'version',
        label: 'Firmware Version',
        value: item => {
          return `
          ${item.version[0]}.${item.version[1]}.${item.version[2]}${item.version[3]} 
          ${item.version[0] == 2 ? `<span style="padding-left: 5px; font-size:12px; text-transform: uppercase;">
            <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="15" height="15" /> Up to date
          </span>` : ''}
          `
        }
      },
    ];

    let html = '';

    // standard sensor details

    values.forEach(value => {

      let rowValue = null;

      if(value.value && isFunction(value.value)) {
        rowValue = value.value(this.currentSensor);
      } else {
        rowValue = this.currentSensor[value.key];
      }

      if(rowValue !== null) {
        html += '<div class="sensor-details__row">';

        if(Branding.currentBrand === 'AF' && value.key === 'last_tcTemp') {
          value.label = "Pipe Temp";
        }

        html += `<div class="sensor-details__label">${value.label}</div>`;
        html += '<div class="sensor-details__value">';
        html += rowValue;
        html += '</div>';
        html += '</div>';
      }

    });

    // network details

    const networkDetails = [
      {
        key: 'wlanA',
        label: item => {

          if(item.version >= 3000) {

            let html = "Primary WiFi";

            return html;

          }

          return `
          Primary WiFi ${item.last_wlan && item.last_wlan == 1 ? `
            <img 
              src="${window.site.home}/../assets/images/icon-check-blue.svg" 
              title="Last accessed WiFi network" 
              width="20" 
              class="sensor-settings-last-network-icon" 
            />
          ` : ''}
          `;
        },
        value: item => {

          let _html = "";

          if(item.version >= 3000) {
            _html = item.wlanA ? item.wlanA : item.last_wlan;
          } else {
            _html = item.wlanA ? item.wlanA : item.ssid;
          }

          if(item.wlan_1_used) {
            const d = window.getUserTimezoneDate(item.wlan_1_used);

            if(d) {
              _html += `
              <div class="sensor-details-network__last-used">
                (Last used ${d.format('MM/DD/YY h:mm a')})
              </div>
              `
            }
          }

          return _html;

        }
      },
      {
        key: 'wlanB',
        label: item => {
          return `
          Backup WiFi ${item.last_wlan && item.last_wlan == 2 ? `
            <img 
              src="${window.site.home}/../assets/images/icon-check-blue.svg" 
              title="Last accessed WiFi network" 
              width="20" 
              class="sensor-settings-last-network-icon" 
            />
          ` : ''}
          `;
        },
        value: item => {

          // only show for v2 sensors
          if(item.version < 2000) {
            return  null;
          }

          if(!item.wlanB || item.wlanB.length === 0) {
            return 'N/A';
          }

          let _html = item.wlanB;

          if(item.wlan_2_used) {
            const d = window.getUserTimezoneDate(item.wlan_2_used);

            if(d) {
              _html += `
              <div class="sensor-details-network__last-used">
                (Last used ${d.format('MM/DD/YY h:mm a')})
              </div>
              `
            }
          }

          return _html;
        }
      },
      {
        key: 'connection_quality',
        label: 'Signal Strength',
        value: item => {

          const rssi_list = [];

          if(item.latest_messages && item.latest_messages.length > 0) {
            item.latest_messages.forEach(message => {
              rssi_list.push(parseInt(message.rssi));
            });

          } else {
            rssi_list.push(parseInt(item.rssi));
          }

          const rssi = median(...rssi_list);

          if(rssi == 0) {
            return null;
          }

          let _html = '';

          if(rssi < -90) {
            _html += `<img width="15" src="${window.site.home + '/images/wifi-no-signal.svg'}" title="Very bad signal quality (${rssi} dB)" />`;
          } else if(rssi < -80) {
            _html += `<img width="15" src="${window.site.home + '/images/wifi-no-bars.svg'}" title="Bad signal quality (${rssi} dB)" />`;
          } else if(rssi < -70) {
            _html += `<img width="15" src="${window.site.home + '/images/wifi-half-bars.svg'}" title="Good signal quality (${rssi} dB)" />`;
          } else {
            _html += `<img width="15" src="${window.site.home + '/images/wifi-full-bars.svg'}" title="Excellent signal quality (${rssi} dB)" />`;
          }

          _html += ` <span class="sensor-details-network__last-rssi">(${rssi} dB)</span>`;

          return _html;

        },
      },
      {
        key: 'connection_time',
        label: 'Time To Connect',
        value: item => {

          let time_to_connect_list = [];

          if(item.last_messages.length > 0) {
            item.last_messages.forEach(message => {
              time_to_connect_list.push(parseInt(message.time_to_connect));
            });

          } else {
            time_to_connect_list.push(parseInt(item.wifi_connect_time));
          }

          const connect_time = median(...time_to_connect_list);

          if(connect_time == -1) {
            return null;
          }

          if(!isNaN(connect_time)) {
            let results = connect_time + ' second';
            if (connect_time > 1) results += 's';
            return results;
          } else {
            return 'N/A';
          }

        },
      },
    ];

    html += '<div class="sensor-details-network">';

    html += `
      <div class="sensor-details-network__header">
        <div class="sensor-details-network__heading">Network Details</div>
        <div class="sensor-details-network__button">
          <button type="button" class="button button--medium sensor-settings-update-wifi-btn">
            Update WiFi
          </button>
        </div>
      </div>
    `;

    html += '<div class="sensor-details-network__content">';

    networkDetails.forEach(networkDetail => {

      let rowLabel;
      let rowValue;

      if(networkDetail.label && isFunction(networkDetail.label)) {
        rowLabel = networkDetail.label(this.currentSensor);
      } else {
        rowLabel = networkDetail.label;
      }

      if(networkDetail.value && isFunction(networkDetail.value)) {
        rowValue = networkDetail.value(this.currentSensor);
      } else {
        rowValue = this.currentSensor[networkDetail.key];
      }

      if(rowValue !== null) {
        html += `
        <div class="sensor-details__row">
          <div class="sensor-details__label">${rowLabel}</div>
          <div class="sensor-details__value">${rowValue}</div>
        </div>
        `;

      }

    });

    html += '</div>';
    html += '</div>';

    // Sensor Management
    // Deleting
    // TODO assigning to other users
    // TODO Sharing with other users?
    // only master accounts can delete sensors
    if(!window.currentUser.is_sub_user) {

      html += '<div class="sensor-details-delete">';

      html += `
      <div class="sensor-details-network__header">
        <div class="sensor-details-network__heading">Management</div>
      </div>
      <div class="sensor-details-network__button">
        <p class="setting__description margin--small">Remove sensor from account permanently</p>
        <button type="button" class="button button--small button--red sensor-settings-delete-sensor">
          Delete Sensor
        </button>
      </div>
    `;

      html += '</div>';

    }

    this.$details.html(html);

  }

  updateConnectionSensitivity() {

    const label = this.$sensor.find('.setting__dropdown__label[data-for="connection_sensitivity"]');
    const value = this.$sensor.find('[name="connection_sensitivity"]').val();

    const send_interval = parseInt(this.$sensor.find('[name="send_interval"]').val());
    let minutes_offline = (send_interval / 60) * value;
    const hours_offline = Math.floor(minutes_offline / 60);

    console.log({
      send_interval,
      minutes_offline,
      hours_offline,
    });

    let offline_str = '';

    if(hours_offline >= 1) {
      minutes_offline = minutes_offline - (60 * hours_offline);
      offline_str = `${hours_offline} hour${hours_offline > 1 ? 's' : ''}${minutes_offline > 0 ? ` ${minutes_offline} minutes` : ''}`
    } else {
      offline_str = `${minutes_offline} minutes`;
    }

    if(value == 1) {
      label.html(`missed reading (up to ${offline_str}) to reconnect before sending a connection loss alert`);
    } else {
      label.html(`missed readings (up to ${offline_str}) to reconnect before sending a connection loss alert`);
    }

  }

  interactions() {

    this.$details.on('click', '.sensor-settings-delete-sensor', () => {

      // Delete Sensor modal
      DeleteSensor({
        sensor: this.currentSensor,
      });

    });

    this.$details.on('click', '.sensor-settings-update-wifi-btn', () => {

      if(this.currentSensor.version < 2000) {
        window.location.href = window.site.home + "/setup";
      } else {
        window.location.href = window.site.home + "/sensors/update-wifi";
      }

    });

    this.$settings.on('change', '[name="send_interval"]', this.updateAlertIntervals.bind(this));
    this.$settings.on('change', '[name="send_interval"]', () => {

      this.SensorLogSecs.updateLogIntervals(this.$settings, this.$settings.find('[name="send_interval"]').val())

    });

    window.addEventListener('popstate', e => {

      const url = new URL(window.location);
      const sensorId = url.searchParams.get('id');

      if(sensorId) {
        this.sensorSelect.selectOption(sensorId);
      }

    });

    // connection sensitivity

    this.$settings.on('change', 'select[name="send_interval"]', e => {

      const $sensitivity = this.$settings.find('select[name="connection_sensitivity"]');

      if($(e.currentTarget).val() <= 1800) {

        if($sensitivity.val() < 2) {
          $sensitivity.val(2);
        }

      }

      this.updateConnectionSensitivity();
    });

    this.$settings.on('change', 'select[name="connection_sensitivity"]', e => {
      this.updateConnectionSensitivity();
    });

    this.$settings.on('input', 'input[type="range"]', e => {

      const slider = $(e.currentTarget);
      const dataFor = slider.attr('name');

      let value = null;

      if(
        dataFor === 'temp_offset' ||
        dataFor === 'probe_temp_offset'
      ) {
        value = `${slider.val()}&deg;${window.currentUser.temp_pref}`;
      } else {
        value = `${slider.val()}%`;
      }

      this.$settings.find(`.setting__value__label[data-for="${dataFor}"]`).html(value);

    });

    this.$settings.on('change', 'input[type="checkbox"]', e => {

      const input = $(e.currentTarget);
      const name = input.attr('name');

      if(input.is(':checked') == true) {
        this.$settings.find(`.setting--conditional[data-for="${name}"]`).toggleClass('is-active', true);
      } else {
        this.$settings.find(`.setting--conditional[data-for="${name}"]`).toggleClass('is-active', false);
      }

    });

    this.$settings.on('change', () => {

      if(
        (window.currentUser.level && window.currentUser.level == 0) ||
        isAccountReadOnly()
      ) {
        return;
      }

      const $message = this.$settings.find('.setting-save__message');
      const $button = this.$settings.find('.setting-save__button button');

      $message.toggleClass('is-error', false);
      $message.html('');
      $button.attr('disabled', false);

    });

    this.$settings.on('submit', 'form', e => {

      e.preventDefault();

      if(!this.currentSensor) return;

      const $form = $(e.currentTarget);
      const $message = $form.find('.setting-save__message');
      const $button = $form.find('.setting-save__button button');

      $button.attr('disabled', true);
      $message.html('Saving...');

      const data = serialize($form[0], {hash: true});

      if(!data.use_sensor_settings) {
        data.use_sensor_settings = 0;
      }

      if (!data.use_alert_interval) {

        data.use_alert_interval = 0;

        // if not using alert interval, set the same as send_interval
        data.alert_interval = data.send_interval;
        data.alert_temp_below = '';
        data.alert_temp_above = '';
        data.alert_humidity_below = '';
        data.alert_humidity_above = '';

      } else {

        if(data.alert_temp_above !== '' && !isNaN(data.alert_temp_above)) {
          data.alert_temp_above = userTempToCelsius(data.alert_temp_above, 2);
        }

        if(data.alert_temp_below !== '' && !isNaN(data.alert_temp_below)) {
          data.alert_temp_below = userTempToCelsius(data.alert_temp_below, 2);
        }

      }

      if (!data.use_offset) {

        data.use_offset = 0;
        data.temp_offset = 0;
        data.humidity_offset = 0;

        if(getProbeSensorTypes()[this.currentSensor.type]) {
          data.probe_temp_offset = 0;
        }

      }

      window.apiRequest('post', `/sensor/${this.currentSensor.sensor_id}`, data).then(r => {

        if(r.type == 'error') {

          $message.toggleClass('is-error', true);
          $message.html(r.message);

        } else {

          this.updateSensorSelect();

          setTimeout(() => {

            $message.toggleClass('is-error', false);
            $message.html('');
            $button.attr('disabled', false);

          }, 500);

        }

      }).catch(reason => {

        $message.toggleClass('is-error', true);
        $message.html(`Couldn't connect to the server to save, please wait and try again`);

        setTimeout(() => {
          $button.attr('disabled', false);
        }, 5000);

      });

    })

  }

  updateSendIntervals() {

    const $send_interval = this.$settings.find('[name="send_interval"]');

    let send_intervals = [];

    if(this.currentSensor.version <= 2000) {
      send_intervals = [
        {label: '1 hour (recommended)', value: 3600},
        {label: '30 minutes', value: 1800},
        {label: '15 minutes', value: 900},
      ];

    } else {
      // v2
      send_intervals = [
        { label: '24 hours', value: 86400 },
        { label: '12 hours', value: 43200 },
        { label: '6 hours', value: 21600 },
        { label: '3 hours', value: 10800 },
        { label: '2 hours', value: 7200 },
        { label: '1 hour (recommended)', value: 3600 },
        { label: '30 minutes', value: 1800 },
        { label: '15 minutes', value: 900 },
      ];
    }

    let options = '';

    send_intervals.forEach(interval => {

      options += `
      <option value="${interval.value}" ${interval.value == this.currentSensor.send_interval ? 'selected' : ''}>
        ${interval.label}
      </option>
    `
    });

    $send_interval.html(options);

  }

  updateAlertIntervals() {

    const send_interval = this.$settings.find('[name="send_interval"]').val();
    const $alert_interval = this.$settings.find('[name="alert_interval"]');

    if(this.currentSensor.version <= 2000) {
      const alert_intervals = {
        3600: [
          1800,
          1200,
          900,
          600,
        ],
        1800: [
          900,
          600,
          300,
        ],
        900: [
          300
        ]
      };

      let options = '';

      alert_intervals[send_interval].forEach(interval => {
        options += `
        <option value="${interval}" ${interval == this.currentSensor.alert_interval ? 'selected' : ''}>
        ${interval / 60} minutes
        </option>
      `
      });

      $alert_interval.html(options);

    } else {
      // v2
      const alert_values = [
        {label: '12 hours', value: 43200},
        {label: '6 hours', value: 21600},
        {label: '3 hours', value: 10800},
        {label: '2 hours', value: 7200},
        {label: '1 hour', value: 3600},
        {label: '30 minutes', value: 1800},
        {label: '15 minutes', value: 900},
        {label: '10 minutes', value: 600},
        {label: '5 minutes', value: 300},
      ];

      let options = '';

      alert_values.forEach(interval => {

        // only smaller intervals
        if(interval.value >= send_interval) {
          return;
        }

        options += `
        <option value="${interval.value}" ${interval.value == this.currentSensor.alert_interval ? 'selected' : ''}>
          ${interval.label}
        </option>
      `
      });

      $alert_interval.html(options);

    }

  }

  sortSensors(sensors) {

    let activeSensors = [];
    let inactiveSensors = [];

    this.sensors.forEach(sensor => {

      if(sensor.offline == 1) {
        inactiveSensors.push(sensor);
      } else {
        activeSensors.push(sensor);
      }

    });

    activeSensors = sort(activeSensors, 'sensor_name');
    inactiveSensors = sort(inactiveSensors, 'sensor_name');

    const items = [];

    activeSensors.forEach(item => {
      items.push({
        value: item.sensor_id,
        label: item.sensor_name,
        offline: item.offline,
      });
    });

    inactiveSensors.forEach(item => {
      items.push({
        value: item.sensor_id,
        label: item.sensor_name,
        offline: item.offline,
      });
    });

    return items;

  }

  init() {

    return new Promise((resolve, reject) => {

      Promise.all(
        [
          getAlerts(false),
          getSensors()
        ]
      ).then(results => {

        this.alerts = results[0];
        this.sensors = results[1];

        const items = this.sortSensors(this.sensors);

        if(items.length > 0) {

          if (window.currentUser.use_sensor_groups && window.currentUser.use_sensor_groups == 1) {

            getSensorGroups().then(groups => {

              this.groups = groups;

              // load sensor groups then init select
              this.initSelect(items);

            });

          } else {
            // default
            this.initSelect(items);
          }

        } else {

          this.$settings.removeClass('loading-overlay');
          this.$details.removeClass('loading-overlay');

          noSensorsOverlay(this.$sensor)

        }

        resolve();

      });

    });

  }

  async updateSensorSelect() {

    this.sensors = await getSensors();
    const items = this.sortSensors(this.sensors);

    if(items.length > 0) {

      this.$sensorSelect.html(`
        ${items.map((item, i) => {
        return `
          <option value="${item.value}" ${item.value == this.currentSensorId ? 'selected' : ''}>
            ${item.label}${item.offline == 1 ? ' (Offline)' : ''}
          </option>
          `
      }).join("\n")}
      `);

    } else {

      // no sensors
      this.$sensorSelect.html('<option value="">No available sensors</option>');

    }

  }

  initSelect(items) {

    if(items.length > 0) {

      this.$sensorSelect.html(`
        ${items.map((item, i) => {
        return `
          <option value="${item.value}" ${item.value == this.currentSensorId ? 'selected' : ''}>
            ${item.label}${item.offline == 1 ? ' (Offline)' : ''}
          </option>
          `
      }).join("\n")}
      `);

      this.$sensorSelect.on('change', () => {
        this.selectSensor(this.$sensorSelect.val());
      });

      this.$sensorSelect.trigger('change');

    } else {

      // no sensors
      this.$sensorSelect.html('<option value="">No available sensors</option>');

    }

  }

}

export default SensorsLite;
